import React from "react";
// wer.webp not available; use blog-hero.webp which exists in assets
import heroBlog from "../assets/images/blog-hero.webp";

const BlogHero = () => {
  return (
    <section
      aria-label="Blogs Hero Section"
      className="relative bg-gradient-to-br from-blue-200 via-blue-100 to-blue-200 py-16 md:py-20 lg:py-24 overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 right-10 w-64 h-64 bg-blue-200 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-80 h-80 bg-indigo-200 rounded-full blur-3xl"></div>
      </div>

      {/* Decorative grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#e2e8f0_1px,transparent_1px),linear-gradient(to_bottom,#e2e8f0_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-20"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 text-center">
        {/* Small badge */}
        <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-6 animate-in slide-in-from-top-5 duration-500">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          <span className="text-sm font-medium tracking-wide">Resource Center</span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 animate-in slide-in-from-bottom-5 duration-500">
          <span className="text-gray-900">Employee Management</span>
          <span className="text-blue-600 block mt-2 md:mt-3">
            Insights & Resources
          </span>
        </h1>

        {/* Description */}
        <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg mt-4 animate-in slide-in-from-bottom-5 duration-700 delay-100">
          Expert insights, best practices, and latest trends in HR technology, 
          workforce optimization, and employee engagement strategies.
        </p>

        

        {/* Topic Tags */}
        <div className="flex flex-wrap justify-center gap-2 mt-8 animate-in slide-in-from-bottom-5 duration-700 delay-300">
          <span className="px-3 py-1 text-xs font-medium text-blue-600 bg-blue-50 rounded-full">
            HR Tech
          </span>
          <span className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-50 rounded-full hover:bg-blue-50 hover:text-blue-600 transition-colors cursor-pointer">
            Payroll Management
          </span>
          <span className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-50 rounded-full hover:bg-blue-50 hover:text-blue-600 transition-colors cursor-pointer">
            Recruitment
          </span>
          <span className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-50 rounded-full hover:bg-blue-50 hover:text-blue-600 transition-colors cursor-pointer">
            Performance Reviews
          </span>
          <span className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-50 rounded-full hover:bg-blue-50 hover:text-blue-600 transition-colors cursor-pointer">
            Remote Work
          </span>
          <span className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-50 rounded-full hover:bg-blue-50 hover:text-blue-600 transition-colors cursor-pointer">
            Employee Engagement
          </span>
        </div>

        {/* Bottom decorative element */}
        <div className="flex justify-center gap-1 mt-10">
          <div className="w-12 h-1 bg-blue-200 rounded-full"></div>
          <div className="w-6 h-1 bg-blue-400 rounded-full"></div>
          <div className="w-3 h-1 bg-blue-600 rounded-full"></div>
        </div>
      </div>

      {/* Animation keyframes */}
      <style>{`
        @keyframes slide-in-from-top-5 {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slide-in-from-bottom-5 {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-in {
          animation-duration: 0.5s;
          animation-fill-mode: both;
        }
        
        .slide-in-from-top-5 {
          animation-name: slide-in-from-top-5;
        }
        
        .slide-in-from-bottom-5 {
          animation-name: slide-in-from-bottom-5;
        }
        
        .delay-100 {
          animation-delay: 100ms;
        }
        
        .delay-200 {
          animation-delay: 200ms;
        }
        
        .delay-300 {
          animation-delay: 300ms;
        }
      `}</style>
    </section>
  );
};

export default BlogHero;